var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._b({attrs:{"type":_vm.btnType,"loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.submitRequest($event)}}},'el-button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }